import React, { Component } from 'react';

import styles from './Hourglass.scss';

class Hourglass extends Component {
  constructor() {
    super();

    this.steps = 31;
    this.animationLength = 2000;
    this.animation = setInterval(this.updateStep, this.animationLength / this.steps);

    this.state = {
      currentStep: 1
    };
  }

  componentDidMount() {
    this.animate();
  }

  animate = () => this.animation;

  updateStep = () => {
    if (this.state.currentStep <= this.steps) {
      const currentStep = this.state.currentStep + 1;
      this.setState({ currentStep });
    } else {
      clearInterval(this.animation);
    }
  }

  render() {
    return (
      <div
        className={`
          ${styles.Hourglass}
          ${this.state.currentStep % 2 === 0 ? styles.reRender : ''}
        `}
      >
        <i className={styles[`icon-xm-hourglass-${this.state.currentStep}`]} />
      </div>
    );
  }
}

export default Hourglass;




// WEBPACK FOOTER //
// ./src/screens/Gas/GasSettings/CalibrateEngineSpeed/Hourglass/Hourglass.js